import { Link } from 'react-router-dom';
import './Style/Home.css';
import TopNavbar from './TopNavbar';
import StudyOption from '../AllData/HomeData';
import { useTrackUser } from '../Component/useTrackUser';
import { usePreventBackButton } from '../Component/usePreventBackButton';




function Home() {

  usePreventBackButton();
  useTrackUser();

  const studyOptions = StudyOption;

  const activeOptions = studyOptions.filter(option => option.status === "true");

  var name = "to JEE Prep App";



  return (
    <div className="study-app">

      <TopNavbar name={name} />

      <header className="app-header">
        <h1>🎯 JEE → 🎓 Engineering</h1>
      </header>

      <br></br>



      <div className="study-grid">
        {activeOptions.map((option) => {


          return (
            <Link
              to={option.link}
              key={option.id}
              className="study-card-link"

            >
              <div
                className="study-card"
                style={{ position: 'relative' }}
              >

                <div className="card-row">
                  <div className="card-icon">
                    <span style={{ fontSize: '70px', lineHeight: 1 }}>
                      {option.symbol}
                    </span>
                  </div>
                  <h3>{option.name} →</h3>
                </div>



              </div>
            </Link>
          );
        })}
      </div>


      <br></br><br></br>





    </div>
  );
}

export default Home;